import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { observer } from 'mobx-react-lite';

import { HeroAndTexTextPartPortrait } from './Components/HeroAndTexTextPartPortrait';
import { ParagraphsColumn } from './Components/ParagraphsColumn';
import { TitleColumn } from './Components/TitleColumn';

type Props = {
  gridCard: GridCard<PlaneTypes.Layout_HeroAndText_TextPart>;
};

export const HeroAndTextTextPart = observer(function HeroAndTextTextPart({
  gridCard,
}: Props) {
  const { data } = gridCard;

  if (data?.styles?.layout === 'landscape') {
    return (
      <group position={[0, gridCard.worldPosition.y, 0]}>
        <TitleColumn gridCard={gridCard} />
        <ParagraphsColumn gridCard={gridCard} />
      </group>
    );
  }

  if (data?.styles?.layout === 'portrait' && data.styles.textPart) {
    return <HeroAndTexTextPartPortrait gridCard={gridCard} />;
  }

  return null;
});
